import { useEffect, useState } from "react";
import ContentLoader from "../../utils/ContentLoader";
import { DatePicker, Modal } from "antd";
import ImagePreviewModal from "../../utils/ImagePreviewModal";
import Select from "react-select";
import { API } from "../../config/constants";
import dayjs from "dayjs";
import { toast } from 'react-toastify';


const { confirm } = Modal;

const statusOptions = [
  { value: "new", label: "New" },
  { value: "accepted", label: "Accepted" },
  { value: "rejected", label: "Rejected" },
];

const recurringOptions = [
  { value: 1, label: "Yes" },
  { value: 0, label: "No" },
];

const recurrenceTypeOptions = [
  { value: "monthly", label: "Monthly" },
  { value: "weekly", label: "Weekly" },
];

const monthlyDayOptions = [
  { value: "first", label: "1st" },
  { value: "second", label: "2nd" },
  { value: "third", label: "3rd" },
  { value: "fourth", label: "4th" },
];

const weeklyDayOptions = [
  { value: "monday", label: "Monday" },
  { value: "tuesday", label: "Tuesday" },
  { value: "wednesday", label: "Wednesday" },
  { value: "thursday", label: "Thursday" },
  { value: "friday", label: "Friday" },
  { value: "saturday", label: "Saturday" },
  { value: "sunday", label: "Sunday" },
];

export default function EventForm({ onSubmit, onCancel, initialData = {}, eventTitleOptions = [], eventDioceseOptions = [], eventParisOptions = [], fetchParishes, }) {
  const isEdit = Boolean(initialData?.id);

  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState({
    church_name: "",
    place: "",
    event_title_id: "",
    status: "new",
    parish_id: "",
    is_recurring: 0,
    recurring_type: "",
    recurring_pattern: "",
    monthly_week: "",
    weekly_day: "",
    church_photo: null,
    previewImage: null,
    start_datetime: null,
    end_datetime: null,
    details: "",
    isSameAsParish: false
  });

  // ------------------ Auto-fill Start/End for new event ------------------
  useEffect(() => {
    if (!initialData || !initialData.id) {
      const now = dayjs();
      setFormData(prev => ({
        ...prev,
        start_datetime: now,
        end_datetime: now.add(1, "hour"),
      }));
    }
  }, [initialData]);

  useEffect(() => {
    if (initialData && initialData.id) {
      const dioceseId = initialData.parish?.diocese?.id;
      const parishId = initialData.parish?.id;

      // Handle monthly recurring pattern prefill
      let monthly_week = "";
      let weekly_day = "";
      if (initialData.is_recurring && initialData.recurring_type === "monthly" && initialData.recurring_pattern) {
        const parts = initialData.recurring_pattern.split("_");
        monthly_week = parts[0] || "";
        weekly_day = parts[1] || "";
      }

      setFormData(prev => ({
        ...prev,
        church_name: initialData.church?.name || "",
        place: initialData.church?.place || "",
        event_title_id: initialData.event_type_id || "",
        status: initialData.status || "new",
        parish_id: parishId ? Number(parishId) : "",
        diocese_id: dioceseId ? Number(dioceseId) : "",
        is_recurring: initialData.is_recurring ? 1 : 0,
        recurring_type: initialData.recurring_type || "",
        recurring_pattern: initialData.recurring_pattern || "",
        monthly_week: monthly_week,   // <-- use split value
        weekly_day: weekly_day,       // <-- use split value
        church_photo: null, // file only
        previewImage: initialData.church_photo ? `${API.IMAGE_BASE_URL}/${initialData.church_photo}` : null,
        start_datetime: initialData.start_datetime ? dayjs(initialData.start_datetime) : null,
        end_datetime: initialData.end_datetime ? dayjs(initialData.end_datetime) : null,
        latitude: initialData.church?.latitude || initialData.parish?.latitude || "",
        longitude: initialData.church?.longitude || initialData.parish?.longitude || "",
        details: initialData.details || "",
      }));

      if (dioceseId) {
        fetchParishes(dioceseId); // load parish options for this diocese
      }
    }
  }, [initialData]);

  const handleChange = (e) => {
    const { name, value, type, files } = e.target;

    if (type === "file" && files[0]) {
      const file = files[0];
      const previewURL = URL.createObjectURL(file);
      setFormData(prev => ({
        ...prev,
        [name]: file,
        previewImage: previewURL,
      }));
      setErrors(prev => ({ ...prev, [name]: "" }));
    } else {
      setFormData(prev => ({
        ...prev,
        [name]: value,
      }));
      setErrors(prev => ({ ...prev, [name]: "" }));
    }
  };

  const updateField = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));

    setErrors(prev => ({
      ...prev,
      [field]: ""
    }));
  };


  // const handleParishChange = (selected) => {

  //   setErrors(prev => ({ ...prev, parish_id: "" }));

  //   confirm({
  //     title: "Is this Parish the same as the Church?",
  //     content: "If yes, Church Name, Latitude, and Longitude will be auto-filled. Otherwise, you can enter manually.",
  //     okText: "Yes",
  //     cancelText: "No",
  //     centered: true,
  //     onOk: () => {
  //       // clear errors for autofilled fields
  //       setErrors(prev => ({
  //         ...prev,
  //         church_name: "",
  //         latitude: "",
  //         longitude: ""
  //       }));

  //       setFormData(prev => {
  //         const newData = {
  //           ...prev,
  //           parish_id: selected.value,
  //           church_name: selected.name || "",
  //           latitude: selected.latitude || "",
  //           longitude: selected.longitude || "",
  //           isSameAsParish: true
  //         };

  //         return newData;
  //       });
  //     },
  //     onCancel: () => {
  //       setFormData(prev => {
  //         const newData = { ...prev, parish_id: selected.value, isSameAsParish: false };
  //         return newData;
  //       });
  //     },
  //   });
  // };

  const validate = () => {
    const newErrors = {};

    // Diocese
    // if (!formData.diocese_id) newErrors.diocese_id = true;

    // Parish
    //if (!formData.parish_id) newErrors.parish_id = true;

    // Church Name
    if (!formData.church_name || !formData.church_name.trim()) {
      newErrors.church_name = true;
    }

    // Place
    if (!formData.place || !formData.place.trim()) {
      newErrors.place = true;
    }


    // Latitude
    // if (
    //   formData.latitude === "" ||
    //   isNaN(formData.latitude) ||
    //   formData.latitude < -90 ||
    //   formData.latitude > 90
    // ) {
    //   newErrors.latitude = true;
    // }

    // // Longitude
    // if (
    //   formData.longitude === "" ||
    //   isNaN(formData.longitude) ||
    //   formData.longitude < -180 ||
    //   formData.longitude > 180
    // ) {
    //   newErrors.longitude = true;
    // }

    // Event Title
    if (!formData.event_title_id) newErrors.event_title_id = true;

    // Start Date
    if (!formData.start_datetime) newErrors.start_datetime = true;

    // End Date
    if (!formData.end_datetime) newErrors.end_datetime = true;

    // Check End Date > Start Date
    if (formData.start_datetime && formData.end_datetime) {
      if (dayjs(formData.end_datetime).isBefore(dayjs(formData.start_datetime))) {
        newErrors.end_datetime = true;
        toast.error("End date must be greater than start date");
      }
    }


    // End Date (only if not recurring)
    // if (formData.is_recurring === 0 && !formData.end_datetime) {
    //   newErrors.end_datetime = true;
    // }

    // Details
    // if (!formData.details || !formData.details.trim()) {
    //   newErrors.details = true;
    // }

    // Church Photo
    // if (!formData.church_photo && !formData.previewImage) {
    //   newErrors.church_photo = true;
    // }

    // Recurring validations
    if (formData.is_recurring === 1) {
      if (!formData.recurring_type) newErrors.recurring_type = true;

      if (formData.recurring_type === "weekly" && !formData.recurring_pattern) {
        newErrors.recurring_pattern = true;
      }

      if (formData.recurring_type === "monthly") {
        if (!formData.monthly_week) newErrors.monthly_week = true;
        if (!formData.weekly_day) newErrors.weekly_day = true;
      }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    const fd = new FormData();
    // if (isEdit) {
    //   fd.append("_method", "PUT");
    // }
    fd.append("church_name", formData.church_name);
    fd.append("place", formData.place);
    fd.append("details", formData.details);
    fd.append("event_type_id", formData.event_title_id);
    fd.append("status", formData.status);
    fd.append("is_recurring", formData.is_recurring);
    fd.append("recurring_type", formData.recurring_type);
    fd.append("recurring_pattern", formData.recurring_pattern);
    fd.append("parish_id", formData.parish_id);
    fd.append("isSameAsParish", formData.isSameAsParish ? 1 : 0);
    fd.append("latitude", formData.latitude ? formData.latitude : "");
    fd.append("longitude", formData.longitude ? formData.longitude : "");
    if (formData.start_datetime) {
      // convert local to UTC before sending
      fd.append("start_datetime", formData.start_datetime.toISOString());
    }

    if (formData.end_datetime) {
      fd.append("end_datetime", formData.end_datetime.toISOString());
    }

    if (formData.church_photo) {
      fd.append("church_photo", formData.church_photo);
    }

    // // ---- Debug log FormData contents ----
    // console.log("Raw formData object:", formData);

    // // Log all key-value pairs in FormData
    // for (let pair of fd.entries()) {
    //   console.log(pair[0], ":", pair[1]);
    // }

    await onSubmit(fd);
  };

  if (loading) return <ContentLoader />;

  return (
    <div className="col-lg-12">
      <div className="card mt-3">
        <div className="card-header">
          <h5 className="card-title mb-0">{isEdit ? "Edit Event" : "Create Event"}</h5>
        </div>

        <div className="card-body">
          <form className="row gy-3" onSubmit={handleSubmit} noValidate>

            {/* Diocese */}
            {/* <div className="col-md-6">
              <label className="form-label">Diocese <span style={{ color: "red" }}>*</span></label>
              <Select
                options={eventDioceseOptions}
                value={eventDioceseOptions.find(option => option.value === formData.diocese_id) || null}
                onChange={(selected) => {
                  updateField("diocese_id", selected.value);
                  updateField("parish_id", null);
                  fetchParishes(selected.value);
                }}
                placeholder="Select Diocese"
                className={`react-select-container ${errors.diocese_id ? "react-select-error" : ""}`}
                classNamePrefix="react-select"
              />
            </div> */}

            {/* Parish */}
            {/* <div className="col-md-6">
              <label className="form-label">Parish <span style={{ color: "red" }}>*</span></label>
              <Select
                options={eventParisOptions}
                value={eventParisOptions.find(option => option.value === formData.parish_id) || null}
                onChange={handleParishChange}
                placeholder="Select Parish"
                isDisabled={!formData.diocese_id}  // disable if no diocese selected
                className={`react-select-container ${errors.parish_id ? "react-select-error" : ""}`}
                classNamePrefix="react-select"
              />
            </div> */}

            {/* Church Name */}
            <div className="col-md-6">
              <label className="form-label">Church Name <span style={{ color: "red" }}>*</span></label>
              <input
                type="text"
                name="church_name"
                value={formData.church_name}
                onChange={handleChange}
                className={`form-control ${errors.church_name ? "is-invalid" : ""}`}
                placeholder="Enter item name"
              />
            </div>

            {/* Place Name */}
            <div className="col-md-6">
              <label className="form-label">Place<span style={{ color: "red" }}>*</span></label>
              <input
                type="text"
                name="place"
                value={formData.place}
                onChange={handleChange}
                className={`form-control ${errors.place ? "is-invalid" : ""}`}
                placeholder="Enter place"
              />
            </div>

            <div className="col-md-6">
              <label className="form-label">Latitude</label>
              <input
                type="text"
                name="latitude"
                value={formData.latitude}
                onChange={handleChange}
                className={`form-control ${errors.latitude ? "is-invalid" : ""}`}
                placeholder="Enter item name"
              />
            </div>
            <div className="col-md-6">
              <label className="form-label">Longitude</label>
              <input
                type="text"
                name="longitude"
                value={formData.longitude}
                onChange={handleChange}
                className={`form-control ${errors.longitude ? "is-invalid" : ""}`}
                placeholder="Enter item name"
              />
            </div>

            {/* Event Title */}
            <div className="col-md-6">
              <label className="form-label">Event Title <span style={{ color: "red" }}>*</span></label>
              <Select
                options={eventTitleOptions}
                value={eventTitleOptions.find(option => option.value === formData.event_title_id) || null}
                onChange={(selected) => updateField("event_title_id", selected.value)}
                placeholder="Select Event Title"
                className={`react-select-container ${errors.event_title_id ? "react-select-error" : ""}`}
                classNamePrefix="react-select"
              />
            </div>

            {/* Status */}
            <div className="col-md-6">
              <label className="form-label">Status<span style={{ color: "red" }}>*</span></label>
              <Select
                options={statusOptions}
                value={statusOptions.find(option => option.value === formData.status) || null}
                onChange={(selected) => updateField("status", selected.value)}
                //isDisabled={!isEdit}
              />
            </div>



            {/* Start Date */}
            {/* <div className="col-md-6">
              <label className="form-label">Start Date<span style={{ color: "red" }}>*</span></label>
              <DatePicker
                showTime={{ format: "hh:mm A", use12Hours: true }}
                className={`form-input ${errors.start_datetime ? "date-error" : ""}`}
                style={{ width: "100%", height: "46px" }}
                format="DD-MM-YYYY hh:mm A"
                value={formData.start_datetime}
                disabledDate={(current) => current && current.isBefore(dayjs().startOf("day"))}
                onChange={(date) => updateField("start_datetime", date)}
                popupClassName="custom-datepicker-popup"
              />
            </div> */}
            {/* Start Date */}
            <div className="col-md-6">
              <label className="form-label">Start Date <span style={{ color: "red" }}>*</span></label>
              <DatePicker
                showTime={{ format: "hh:mm A", use12Hours: true }}
                className={`form-input ${errors.start_datetime ? "date-error" : ""}`}
                style={{ width: "100%", height: "46px" }}
                format="DD-MM-YYYY hh:mm A"
                value={formData.start_datetime}
                disabledDate={(current) => current && current.isBefore(dayjs().startOf("day"))}
                onChange={(date) => {
                  updateField("start_datetime", date);
                  // auto-update end date if empty or before start
                  if (!formData.end_datetime || dayjs(formData.end_datetime).isBefore(date)) {
                    updateField("end_datetime", date.add(1, "hour"));
                  }
                }}
              />
            </div>

            {/* End Date */}
            <div className="col-md-6">
              <label className="form-label">End Date <span style={{ color: "red" }}>*</span></label>
              <DatePicker
                showTime={{ format: "hh:mm A", use12Hours: true }}
                className={`form-input ${errors.end_datetime ? "date-error" : ""}`}
                style={{ width: "100%", height: "46px" }}
                format="DD-MM-YYYY hh:mm A"
                value={formData.end_datetime}
                disabledDate={(current) => current && current.isBefore(dayjs().startOf("day"))}
                onChange={(date) => updateField("end_datetime", date)}
              />
            </div>

            {/* End Date */}
            {/* <div className="col-md-6">
              <label className="form-label">End Date<span style={{ color: "red" }}>*</span></label>
              <DatePicker
                showTime={{ format: "hh:mm A", use12Hours: true }}
                className={`form-input ${errors.end_datetime ? "date-error" : ""}`}
                style={{ width: "100%", height: "46px" }}
                format="DD-MM-YYYY hh:mm A"
                value={formData.end_datetime}
                disabledDate={(current) => current && current.isBefore(dayjs().startOf("day"))}
                onChange={(date) => updateField("end_datetime", date)}
                popupClassName="custom-datepicker-popup"
              />
            </div> */}

            {/* Recurring Prayer */}
            <div className="col-md-6">
              <label className="form-label">Recurring Prayer<span style={{ color: "red" }}>*</span></label>
              <Select
                options={recurringOptions}
                value={recurringOptions.find(option => option.value === formData.is_recurring) || null}
                onChange={(selected) => updateField("is_recurring", Number(selected.value))} />
            </div>


            {/* Recurrence Type */}
            {formData.is_recurring === 1 && (
              <div className="col-md-6">
                <label className="form-label">Recurrence Type</label>
                <Select
                  options={recurrenceTypeOptions}
                  value={recurrenceTypeOptions.find(option => option.value === formData.recurring_type) || null}
                  onChange={selected => {
                    // Update recurrence type and reset monthly/weekly selections
                    updateField("recurring_type", selected.value);
                    updateField("monthly_week", "");
                    updateField("weekly_day", "");
                    updateField("recurring_pattern", "");
                  }}
                  className={`react-select-container ${errors.recurring_type ? "react-select-error" : ""}`}
                  classNamePrefix="react-select"
                />
              </div>
            )}

            {/* Monthly Recurrence */}
            {formData.recurring_type === "monthly" && formData.is_recurring === 1 && (
              <>
                {/* Week of Month */}
                <div className="col-md-6">
                  <label className="form-label">Week of Month</label>
                  <Select
                    options={monthlyDayOptions}
                    value={monthlyDayOptions.find(option => option.value === formData.monthly_week) || null}
                    onChange={selected => {
                      updateField("monthly_week", selected.value);
                      // Update recurring_pattern if weekly_day is selected
                      if (formData.weekly_day) {
                        updateField("recurring_pattern", `${selected.value}_${formData.weekly_day}`);
                      }
                    }}
                    className={`react-select-container ${errors.monthly_week ? "react-select-error" : ""}`}
                    classNamePrefix="react-select"
                  />
                </div>

                {/* Day of Week */}
                <div className="col-md-6">
                  <label className="form-label">Day of Week</label>
                  <Select
                    options={weeklyDayOptions}
                    value={weeklyDayOptions.find(option => option.value === formData.weekly_day) || null}
                    onChange={selected => {
                      updateField("weekly_day", selected.value);
                      // Update recurring_pattern if monthly_week is selected
                      if (formData.monthly_week) {
                        updateField("recurring_pattern", `${formData.monthly_week}_${selected.value}`);
                      } else {
                        updateField("recurring_pattern", selected.value);
                      }
                    }}
                    className={`react-select-container ${errors.weekly_day ? "react-select-error" : ""}`}
                    classNamePrefix="react-select"
                  />
                </div>
              </>
            )}

            {/* Weekly Recurrence */}
            {formData.recurring_type === "weekly" && formData.is_recurring === 1 && (
              <div className="col-md-6">
                <label className="form-label">Day of Week</label>
                <Select
                  options={weeklyDayOptions}
                  value={weeklyDayOptions.find(option => option.value === formData.recurring_pattern) || null}
                  onChange={selected => updateField("recurring_pattern", selected.value)}
                  className={`react-select-container ${errors.recurring_pattern ? "react-select-error" : ""}`}
                  classNamePrefix="react-select"
                />
              </div>
            )}


            {/* Image */}
            <div className="col-md-6">
              <label className="form-label">Image</label>
              <input type="file" name="church_photo" className={`form-control ${errors.church_photo ? "is-invalid" : ""}`} onChange={handleChange} />
              {(formData.previewImage || formData.church_photo) && (
                <div className="mt-3">
                  <ImagePreviewModal
                    src={formData.previewImage}
                    alt="Preview"
                    thumbWidth={80}
                    thumbHeight={80}
                  />
                </div>
              )}
            </div>

            {/* Details */}
            <div className="col-md-12">
              <label className="form-label">Details</label>
              <textarea
                name="details"
                value={formData.details}
                onChange={handleChange}
                className={`form-control ${errors.details ? "is-invalid" : ""}`}
                rows={2}
              />
            </div>

            {/* Submit */}
            <div className="col-12 d-flex justify-content-end mt-3 gap-2">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={onCancel}
              >
                Cancel
              </button>

              <button type="submit" className="btn btn-primary">
                {isEdit ? "Update Event" : "Create Event"}
              </button>
            </div>

          </form>
        </div>
      </div>
    </div>
  );
}